<ngx-spinner [zIndex]="100000" type="ball-clip-rotate"><p style="font-size: 20px; color: white">Please wait while the request is processed...</p></ngx-spinner>
<app-menu></app-menu>
<app-toolbar></app-toolbar>
<app-breadcrumb></app-breadcrumb>
<router-outlet></router-outlet>